import * as React from 'react';
import classNames from 'classnames';
import { SkinScreenWidthContainerProps } from '../../../SkinScreenWidthContainer';
import skinsStyle from './styles/skins.scss';

const LiftedBottomScreen: React.FC<SkinScreenWidthContainerProps> = ({
  wrapperProps: {
    id,
    tagName = 'div',
    eventHandlers,
    className: propsClassName,
  },
  children,
  animation,
}) => {
  const SemanticElement = tagName as keyof JSX.IntrinsicElements;

  return (
    <SemanticElement
      id={id}
      className={classNames(
        skinsStyle.LiftedBottomScreen,
        animation && skinsStyle[animation],
        propsClassName,
      )}
      {...eventHandlers}
    >
      <div className={skinsStyle.screenWidthBackground}></div>
      <div className={skinsStyle.centeredContent}>
        <div className={skinsStyle.centeredContentBg}>
          <div
            className={`${skinsStyle.shadow} ${skinsStyle.leftBottom}`}
          ></div>
          <div
            className={`${skinsStyle.shadow} ${skinsStyle.centerBottom}`}
          ></div>
          <div
            className={`${skinsStyle.shadow} ${skinsStyle.rightBottom}`}
          ></div>
          <div className={skinsStyle.border}>
            <div className={skinsStyle.bg}></div>
          </div>
        </div>
        <div className={skinsStyle.inlineContent}>{children}</div>
      </div>
    </SemanticElement>
  );
};

export default LiftedBottomScreen;
